import { memo } from 'react';

import { DualTime, Typography } from '@/ui';
import { daysBetween } from '@/utils/dates';

import type { Props } from './types';

const EpisodeOfCareItem = ({ children, label, startAt, timeZone }: Props) => (
  <div>
    <Typography muted>{label}</Typography>
    <Typography variant="subheading" className="mp-sensitive">
      {children}
    </Typography>
    {startAt && (
      <Typography muted>
        <DualTime
          dateTime={new Date(startAt)}
          memberTZ={timeZone}
          primaryTimeZone="member"
          className="text-uniform-gray-600 dark:text-uniform-gray-400"
        />
        {' • '}
        <Typography as="span" weight="semibold">
          {`${daysBetween(new Date(startAt))} days`}
        </Typography>
      </Typography>
    )}
  </div>
);

export default memo(EpisodeOfCareItem);
